import { Result, failure, success } from '../shared'
import { UtilityProvider } from './utility.provider'
import { UtilityServiceErrorCode, CollateralManagementServerData } from './utility.types'

export class UtilityService {
  constructor(private provider: UtilityProvider) {}

  public async unicodeToLatin(unicodeText: string): Promise<Result<string>> {
    try {
      const { data } = await this.provider.unicodeToLatin(unicodeText)
      return success(data.Text)
    } catch (error) {
      return failure(UtilityServiceErrorCode.GENERAL)
    }
  }

  public async getCollateralManagementSession(): Promise<Result<CollateralManagementServerData>> {
    try {
      const { data } = await this.provider.getCollateralManagementSession()
      return success(data)
    } catch (error) {
      return failure(UtilityServiceErrorCode.GENERAL)
    }
  }
}
